// Module-level mirror of the user's active network. Mutated by
// `NetworkSyncProvider` whenever the Zustand store changes; read by
// non-React utility functions that can't subscribe to the store
// (`getUsdcMint`, `getSolscanTxUrl`, `getApiHeaders`, etc.).
//
// Reactivity: component re-renders are NOT triggered by reads of the
// singleton. Components must use `useUserNetwork()` / `useNetworkConfig()`
// to re-render on toggle. Module-level utilities just return the new
// value on their next call after `NetworkSyncProvider` has fired (which
// it does inside an `useEffect` that also calls `queryClient.clear()`,
// so cached calls get re-evaluated).
//
// SSR / server: the singleton holds the deployment default. Server
// Components that need the user's runtime network should read the
// cookie via `getServerNetwork()` from `./server` instead.

import { getDefaultNetwork } from './config';
import type { Network } from './types';

let activeNetwork: Network = getDefaultNetwork();

/** Bind the active network for module-level utility functions.
 *  Called by `NetworkSyncProvider` on mount and on every toggle. */
export function setActiveNetwork(network: Network): void {
  activeNetwork = network;
}

/** Read the active network. Use this in non-React utilities; in React
 *  components use `useUserNetwork()` for reactive subscription. */
export function getActiveNetwork(): Network {
  return activeNetwork;
}
